export const Translations_UA = {
	footer: {
		join: "Доєднуйтесь просто зараз. Додаток та реєстрація не потрібні.",
		climate: "Клімат-позитивне обговорення.",
		tree: "Це дерево було посаджено.",
		start: "Почніть відеообговорення безкоштовно.",
	},
};
